export default {"src":"/_next/static/media/step1b.1f98c9f0.svg","height":18,"width":20,"blurWidth":0,"blurHeight":0};